import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import DraftReminder from 'www/vue_components/common/DraftReminder/components/DraftReminder.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/DraftReminder/constants'

const el = document.querySelector(MOUNT_SELECTOR)

const mount = async () => {
  await initI18n({ bundle: 'vue_components/common/DraftReminder' })

  if (el) {
    new Vue({
      vuetify,
      el,
      render: h => h(DraftReminder),
    })
  }
}

mount()
